enum EquityAccountType {
  ASK = 'ASK',
  NOMI = 'NOMI',
  NBRK = 'NBRK',
  NCON = 'NCON',
  NASS = 'NASS',
}
export default EquityAccountType;
